"use client";

import { c as _c } from "react/compiler-runtime";
import { Plus } from "lucide-react";
import { AssistantInsights } from "@/components/assistant/assistant-insights";
import { DashboardOverview } from "@/components/dashboard/dashboard-overview";
import { FinancialSummary } from "@/components/dashboard/financial-summary";
import { RecentActivity } from "@/components/dashboard/recent-activity";
import { PageWrapper } from "@/components/page-wrapper";
import { ButtonLink } from "@/components/ui/button";
import { SectionStack } from "@/components/ui/section";

/**
 * Organization dashboard. `pending` renders every section in its loading state without
 * querying; the app shell shows it while auth resolves, so a reload already has the loaded
 * page's header and section layout instead of a generic loading screen.
 */
export function DashboardPage(t0) {
  const $ = _c(20);
  const {
    organizationSlug,
    subscriptionLocked: t1,
    pending: t2
  } = t0;
  const subscriptionLocked = t1 === undefined ? false : t1;
  const pending = t2 === undefined ? false : t2;
  const t3 = `/${organizationSlug}/projects/new`;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Plus />;
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  let t5;
  if ($[1] !== t3) {
    t5 = <ButtonLink size="sm" href={t3}>{t4}Novo projeto</ButtonLink>;
    $[1] = t3;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== organizationSlug || $[4] !== pending || $[5] !== subscriptionLocked) {
    t6 = !subscriptionLocked ? <AssistantInsights organizationSlug={organizationSlug} pending={pending} /> : null;
    $[3] = organizationSlug;
    $[4] = pending;
    $[5] = subscriptionLocked;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  let t8;
  let t9;
  if ($[7] !== pending || $[8] !== subscriptionLocked) {
    t7 = <DashboardOverview pending={pending} subscriptionLocked={subscriptionLocked} />;
    t8 = <FinancialSummary pending={pending} subscriptionLocked={subscriptionLocked} />;
    t9 = <RecentActivity pending={pending} subscriptionLocked={subscriptionLocked} />;
    $[7] = pending;
    $[8] = subscriptionLocked;
    $[9] = t7;
    $[10] = t8;
    $[11] = t9;
  } else {
    t7 = $[9];
    t8 = $[10];
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t6 || $[13] !== t7 || $[14] !== t8 || $[15] !== t9) {
    t10 = <SectionStack>{t6}{t7}{t8}{t9}</SectionStack>;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t5) {
    t11 = <PageWrapper actions={t5} title="Dashboard">{t10}</PageWrapper>;
    $[17] = t10;
    $[18] = t5;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  return t11;
}